module.exports = __webpack_public_path__ + "static/media/loader2.7eb39045.svg";